import { createSelector } from 'redux-orm';
import isUndefined from 'lodash/isUndefined';

import orm from '../orm';
import Config from '../constants/Config';

const nextPosition = (items, index, excludedId) => {
  const filteredItems = isUndefined(excludedId)
    ? items
    : items.filter((item) => item.id !== excludedId);

  if (isUndefined(index)) {
    const lastItem = filteredItems[filteredItems.length - 1];

    return (lastItem ? lastItem.position : 0) + Config.POSITION_GAP;
  }

  const prevItem = filteredItems[index - 1];
  const nextItem = filteredItems[index];

  const prevPosition = prevItem ? prevItem.position : 0;

  if (!nextItem) {
    return prevPosition + Config.POSITION_GAP;
  }

  return prevPosition + (nextItem.position - prevPosition) / 2;
};

export const nextSitePositionSelector = createSelector(
  orm,
  (_, factoryId) => factoryId,
  (_, __, index) => index,
  (_, __, ___, excludedId) => excludedId,
  ({ Factory }, factoryId, index, excludedId) => {
    const factoryModel = Factory.withId(factoryId);

    if (!factoryModel) {
      return factoryModel;
    }

    return nextPosition(factoryModel.getOrderedSitesQuerySet().toRefArray(), index, excludedId);
  },
);

export const nextLinePositionSelector = createSelector(
  orm,
  (_, siteId) => siteId,
  (_, __, index) => index,
  (_, __, ___, excludedId) => excludedId,
  ({ Site }, siteId, index, excludedId) => {
    const siteModel = Site.withId(siteId);

    if (!siteModel) {
      return siteModel;
    }

    return nextPosition(siteModel.getOrderedLinesQuerySet().toRefArray(), index, excludedId);
  },
);

export const nextDevicePositionSelector = createSelector(
  orm,
  (_, lineId) => lineId,
  (_, __, index) => index,
  (_, __, ___, excludedId) => excludedId,
  ({ Line }, lineId, index, excludedId) => {
    const lineModel = Line.withId(lineId);

    if (!lineModel) {
      return lineModel;
    }

    return nextPosition(lineModel.getOrderedFilteredDevicesModelArray(), index, excludedId);
  },
);

export const nextDiagramIdSelector = createSelector(orm, ({ Diagram }) => {
  const diagrams = Diagram.getOrderedQuerySet().toRefArray();
  let nextId = 1;
  if (diagrams.length > 0 && diagrams[0].id) nextId = parseInt(diagrams[0].id, 10) + 1;

  return nextId.toString();
});
